<span [ngClass]="[row?.active === true ? 'active-status' : '', activeLanguage$ | async]">
  {{ row?.active ? ('myAccount.active' | cxTranslate) : ('myAccount.inactive' | cxTranslate) }}</span
>
